import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Modal,
  Stack,
  TablePagination,
  TextField,
  Typography,
  Paper,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Autocomplete,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DeleteOutline, EditOutlined, InfoOutlined } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import DeleteAlert from "../AlertBox/DeleteAlert";
import { useDispatch, useSelector } from "react-redux";
import {
  editCompanyStatus,
  getHiringCompanyData,
  getHiringCompanyThroughData,
  postHiringCompanyInFlow,
  updateIflowHiringCompany,
} from "../../Redux/HiringCompany/action";
import { postRecruitmentCompanyInFlow } from "../../Redux/RecruitmentCompany/action";
import { Controller, useForm } from "react-hook-form";
import PeopleToNotifyRepeater from "../../Pages/PeopleToNotifyRepeater.jsx";
import TemplateRepeater from "../../Pages/TemplateRepeater.jsx";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import "../../Pages/RecruiterTabDashboard.css";
import { getCountryData } from "../../Redux/Country/action";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { IOSSwitchButton } from "../ReusableComponents/SwitchButtons.js";
import {
  editRecruitmentCompanyActionFn,
  getIflowChildCompanyUsingParentId,
  getRecruitmentCompanyActionFn,
} from "../../Redux/RecruitmentCompany/action.js";
import {
  columns,
  getMasterCompanyNameByMasterCompany,
  validatePeopleToBeNotified,
} from "../../constants/recruiterTab";
import ReuseableLabel from "../ReusableComponents/ReuseableLabel.jsx";
import EmailRepeaters from "../Repeaters/EmailRepeaters.jsx";
import {
  getChildCompanies,
  getCompanyNumber,
} from "../../Redux/Templates/action";
import { getOpeningByCompanyActionFn } from "../../Redux/QuestionPacakge/action";
import { removePlusFromPhoneNumber } from "../../utils/helperFunctions.js";
import { roleModulePermissions } from "../../utils/roleInstance";
import IButtonModal from "../Modals/IButtonModal.jsx";
import { useColorMode } from "../../hooks/useColorMode.js";
import ApiAlert from "../AlertBox/ApiAlert.jsx";
import { useDebounce } from "../../hooks/useDebounce.js";
import { useGoogleTranslate } from "../../services/GoogleTranslateContext";

const useStyles = makeStyles((theme) => ({
  editIconButton: {
    "&:hover": { color: "rgb(254, 154, 37)", cursor: "pointer" },
  },
  deleteIconButton: {
    "&:hover": {
      color: "red", // Set deleteIconButton hover text color here
    },
  },
  tableRow: {
    "& .MuiTableCell-root": {
      borderRight: `1px solid ${theme.palette?.grey[200]}`,
      borderBottom: "none",
      padding: 5,
      paddingTop: 8,
      paddingBottom: 8,
      cursor: "pointer",
      minWidth: 25,
      //this works but only for cell hover, not the full row
      "&:hover": {
        backgroundColor: "red",
      },
    },
  },
  sticky: {
    // position: "sticky",
    // right: 0,
  },
}));

const RecruiterTable = ({
  recruitmentData,
  // recruitmentCompanyData,
  deleteRecruiterCompany,
  handleChangeSwitch,
  open,
  setOpen,
  editRecruiterCompanyDetails,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  recruitmentDataLength,
  countryDetails,
  countrySelected,
}) => {
  // const { reinitializeGoogleTranslate } = useGoogleTranslate();

  const classes = useStyles();
  const [editModal, setEditModal] = React.useState(false);
  const [masterCompanyVal, setMasterCompanyVal] = useState({});
  const [selectedEditData, setSelectedEditData] = React.useState({});
  // const [idToDelete, setIdToDelete] = useState(null);
  const [switchInactive, setSwitchInactive] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showDesc, setShowDesc] = useState("");

  const dispatch = useDispatch();
  const { getThemeColor } = useColorMode();
  const hiringCompanies = useSelector(
    (state) => state.hiringCompanyReducer.hiringCompany,
  );

  const [templateClick, setTemplateClick] = useState(true);
  const [childMetaCompany, setChildMetaCompany] = useState([]);
  const [recruiterMetaCompany, setRecruiterMetaCompany] = useState([]);
  const [metaCompanyDetails, setMetaCompanyDetails] = useState([]);
  const [metaRecruiterCompanyDetails, setMetaRecruiterCompanyDetails] =
    useState([]);
  const [filteredMetaCompany, setFilteredMetaCompany] = useState([]);
  const [search, setSearch] = useState("");
  const { debouncedValue } = useDebounce(search, 1500);

  useEffect(() => {
    dispatch(getChildCompanies()).then((res) => {
      setMetaCompanyDetails(res.payload);
      dispatch(
        getRecruitmentCompanyActionFn(page + 1, 5000, debouncedValue),
      ).then((res) => {
        setMetaRecruiterCompanyDetails(res.payload);
      });
    });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    // Extract the childMetaCompany IDs to exclude
    const excludedIds = metaRecruiterCompanyDetails.map(
      (item) => item.childMetaCompany,
    );
    // Filter metaCompanyDetails to exclude matching IDs
    const filtered = metaCompanyDetails.filter(
      (item) =>
        !excludedIds.includes(item.id) ||
        (selectedEditData.childMetaCompany && item.id == selectedEditData.childMetaCompany),
    );
    // Update state with the filtered list
    setFilteredMetaCompany(filtered);
  }, [selectedEditData, metaRecruiterCompanyDetails, metaCompanyDetails]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClickOpen = (data) => {
    setOpen(true);
    setSwitchInactive(data);
  };

  const handleClose = () => {
    setOpen(false);
    setTemplateClick(true);
  };

  useEffect(() => {
    dispatch(getHiringCompanyData(1, 5000));
  }, []);
  useEffect(() => {
    if (page !== 0) {
      setPage(0);
    }
  }, [recruitmentDataLength]);
  //console.log("recruitmentData", recruitmentData);
  const rows = recruitmentData.filter((el) => el.companyType != "master");

  const handleEditRecruiterCompany = (row) => {
    // console.log("row", row);
    setSelectedEditData(row);
    let masterCompanyValue = hiringCompanies.filter(
      (company) => company.CompanyId === row.masterCompanyId,
    );
    setMasterCompanyVal(
      masterCompanyValue.length > 0
        ? masterCompanyValue[0]
        : { id: 0, name: "No Hiring company", CompanyId: "" },
    );

    if (row.recruiterMetaCompany != undefined) {
      const recruiterCompanyData = metaCompanyDetails.filter(
        (val) => val.id === row.recruiterMetaCompany,
      );
      setRecruiterMetaCompany(recruiterCompanyData);
    } else {
      setRecruiterMetaCompany("");
    }

    if (row.childMetaCompany != undefined) {
      const childCompanyData = metaCompanyDetails.filter(
        (val) => val.id === row.childMetaCompany,
      );
      setChildMetaCompany(childCompanyData);
    } else {
      setChildMetaCompany("");
    }

    setEditModal(true);
  };
  // console.log("wertyuiop[", recruitmentData);

  // Check Role Permission
  const [recruiterEditAction, setRecruiterEditAction] = useState("");
  const [recruiterDeleteAction, setRecruiterDeleteAction] = useState("");

  const checkRecruiterEditAction = async () => {
    const roleData = {
      roleModule: "Recruitment Company",
    };
    let rolePermission = await roleModulePermissions.checkUserRoles(
      roleData,
      "edit",
    );
    // return rolePermission
    setRecruiterEditAction(rolePermission);
  };

  const checkRecruiterDeleteAction = async () => {
    const roleData = {
      roleModule: "Recruitment Company",
    };
    let rolePermission = await roleModulePermissions.checkUserRoles(
      roleData,
      "delete",
    );
    // return rolePermission
    setRecruiterDeleteAction(rolePermission);
  };

  /* useEffect(() => {
    if (rows.length > 0) {
      console.log("API data loaded. Reinitializing Google Translate...");
      setTimeout(() => {
        reinitializeGoogleTranslate(); // Reapply translation to new content
      }, 2000); // Add slight delay to ensure content is rendered before translation
    }
  }, [rows]); // Runs when `rows` (API data) is updated */

  useEffect(() => {
    checkRecruiterEditAction();
    checkRecruiterDeleteAction();
  }, [page]);

  // Check Role Permission

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        // backgroundColor: "red",
        //overflow: "scroll",
      }}
    >
      <Paper sx={{ width: "100%" }}>
        <TableContainer
          //className={classes.height}
          sx={{
            //maxHeight: 515
            // height: "80vh",
            maxHeight: "calc(100vh - 168px)",
          }}
        >
          <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column, index) => {
                  return (
                    <TableCell
                      sx={{
                        // backgroundColor: "rgb(30, 13, 97)",
                        // color: "rgb(254, 154, 37)",
                        backgroundColor: "primary.main",
                        color: "secondary.main",
                        minWidth: column.minWidth,
                      }}
                      key={index}
                      align={column.align}
                      className={
                        column.id === "Action" ? classes.sticky : "null"
                      }
                    >
                      {column.id === "Action"
                        ? (recruiterEditAction != undefined &&
                          recruiterEditAction != "") ||
                          (recruiterDeleteAction != undefined &&
                            recruiterDeleteAction != "")
                          ? column.label
                          : ""
                        : column.label}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    cursor: row.companyStatus ? "pointer" : "not-allowed",
                    opacity: row.companyStatus ? 1 : 0.6, // makes disabled rows look dimmed
                    backgroundColor: (theme) =>
                      row.companyStatus
                        ? theme.palette.background.paper // normal
                        : theme.palette.action.disabledBackground, // subtle grey for disabled
                    "&:hover": {
                      backgroundColor: (theme) =>
                        row.companyStatus
                          ? theme.palette.action.hover
                          : theme.palette.action.disabledBackground, // prevent hover color on disabled
                    },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <TableCell component="th" scope="row" align="right">
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell align="left">{row?.name}</TableCell>
                  <TableCell align="left">
                    {row?.website == "" ? "N/A" : row?.website}
                  </TableCell>
                  <TableCell align="left">
                    {row?.description === "" ? (
                      "N/A"
                    ) : row?.description?.length <= 27 ? (
                      row?.description
                    ) : (
                      <>
                        {row?.description?.slice(0, 20) + "...."}
                        {row?.description ? (
                          <Tooltip
                            title={"Click to view full description."}
                            arrow
                          >
                            <IconButton
                              onClick={(event) => {
                                setAnchorEl(event.currentTarget);
                                setShowDesc(row?.description);
                              }}
                            >
                              <InfoOutlined sx={{ fontSize: "15px" }} />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                        <IButtonModal
                          type={"text"}
                          element={showDesc}
                          anchorEl={anchorEl}
                          setAnchorEl={setAnchorEl}
                        />
                      </>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {row?.masterCompanyName ? row?.masterCompanyName : "N/A"}
                  </TableCell>
                  <TableCell align="left">
                    {row?.phone_number ? row?.phone_number : "N/A"}
                  </TableCell>
                  <TableCell align="left">
                    {row?.phone_number_id ? row?.phone_number_internal : "N/A"}
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.sticky}
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent={"center"}
                      alignItems={"center"}
                      // position={"sticky"}
                      // spacing={1}
                      spacing={row.companyStatus ? 2 : 5}
                    >
                      {recruiterEditAction != "" &&
                        recruiterEditAction != undefined ? (
                        <Tooltip
                          title="Edit Recruitment Company"
                          arrow
                          placement="top"
                        >
                          <EditOutlined
                            fontSize="medium"
                            className={classes.editIconButton}
                            onClick={() => handleEditRecruiterCompany(row)}
                            // style={{display:"none"}}

                            sx={{
                              display:
                                row.companyStatus === true ? "block" : "none",
                            }}
                          />
                        </Tooltip>
                      ) : (
                        ""
                      )}
                      {/* <DeleteOutline
                        fontSize="medium"
                        className={classes.deleteIconButton}
                        onClick={() => handleClickOpen(row.CompanyId)}
                        sx={{
                          display:
                            row.companyStatus === false ? "block" : "none",
                        }}
                      /> */}
                      {recruiterDeleteAction != "" &&
                        recruiterDeleteAction != undefined ? (
                        <Tooltip
                          title={row.companyStatus ? "Disable" : "Enable"}
                          arrow
                          placement="top"
                        >
                          <Box sx={{ transform: "scale(0.7)" }}>
                            <IOSSwitchButton
                              size="small"
                              onClick={
                                row.companyStatus === false
                                  ? () => handleChangeSwitch(row)
                                  : () => handleClickOpen(row)
                              }
                              checked={row.companyStatus === true}
                            />
                          </Box>
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          // rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={recruitmentDataLength}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        // onClick={reinitializeGoogleTranslate}
        />
      </Paper>
      <DeleteAlert
        open={open}
        onClose={handleClose}
        handleClose={handleClose}
        handleDelete={() => handleChangeSwitch(switchInactive)}
        rightButton={"Inactive"}
        header={"Inactive"}
        message={
          "This will make all the campaigns associated with this company inactive. Are you sure you want to make  this item inactive?"
        }
      />
      <EditRecruiterCompanyModal
        open={editModal}
        setOpen={setEditModal}
        data={selectedEditData}
        editRecruiterCompanyDetails={editRecruiterCompanyDetails}
        masterCompanyVal={masterCompanyVal}
        hiringCompanies={hiringCompanies}
        countryDetails={countryDetails}
        recruiterMetaData={recruiterMetaCompany}
        childMetaData={childMetaCompany}
        defaultCountry={countrySelected}
        metaRecruiterCompanyDetails={metaCompanyDetails}
        allMetaCompanyDetails={metaCompanyDetails}
      />
    </Box>
  );
};

export default RecruiterTable;

////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Edit Recruitment Company(MODAL)

export const schema = yup.object().shape({
  name: yup
    .string()
    .matches(
      /^(?=.*[A-Za-z&])[\w&,().:; -]*[A-Za-z&][\w&,().:; -]*$/,
      "Invalid recruitment company (& , ( ) . : ; - are allowed with alphabetic characters)",
    )
    .test(
      "not-only-special-characters",
      "not-only-special-characters",
      (value) => {
        return /[^\W_]/.test(value);
      },
    )
    .nullable(),
  website: yup
    .string()
    .required("Company Website is required")
    .matches(/^(http|https|www)/, "Invalid company website format"),
  companyForHint: yup
    .string()
    .required("Company abbreviation is required")
    // .matches(
    //   /^[A-Za-z& 0-9]*[A-Za-z][A-Za-z& 0-9]*$/,
    //   'Must include at least one alphabetic character. "&" is allowed.'
    // )
    .test(
      "not-only-numbers",
      "Value must include at least one non-numeric character",
      (value) => {
        return /\D/.test(value);
      },
    ),
  phone_number: yup
    .string()
    .required("WhatsApp candidate connect # is required ")
    .matches(/^\d+$/, "Phone number must contain only numbers")
    .min(10, "Phone number must be at least 10 to 15 characters")
    .max(15, "Phone number must be at least 10 to 15 characters"),
  phone_number_id: yup
    .string()
    .required("WhatsApp candidate connect meta ID is required")
    .matches(/^\d+$/, "Phone number must contain only numbers"),
  phone_number_internal: yup
    .string()
    .required("WhatsApp recruiter connect # is required ")
    .matches(/^\d+$/, "Phone number internal must contain only numbers")
    .min(10, "Phone number must be at least 10 to 15 characters")
    .max(15, "Phone number must be at least 10 to 15 characters"),
  phone_number_id_internal: yup
    .string()
    .required("WhatsApp recruiter connect meta ID is required ")
    .matches(/^\d+$/, "Phone number id internal must contain only numbers"),
  reapplyDuration: yup.string().required("Reapply duration is required"),
  // linkedinPage: yup
  //   .string()
  //   .required()
  //   .matches(
  //     /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/,
  //     "Invalid LinkedIn page link"
  //   ),
  // instagramPage: yup
  //   .string()
  //   .matches(
  //     /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?$/,
  //     "Invalid Instagram page link"
  //   ),
  // careerPage: yup
  //   .string()
  //   .matches(
  //     /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.careerpage\.com\/?$/,
  //     "Invalid Career page link"
  //   ),
  // xHandle: yup
  //   .string()
  //   .matches(
  //     /^(https?:\/\/)?(www\.)?[a-zA-Z0-9_-]+\.com\/x\/[a-zA-Z0-9_-]+\/?$/,
  //     "Invalid X Handle page link"
  //   ),
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "80%",
  overflow: "scroll",
  width: "55%",
  bgcolor: "background.paper",
  border: "0px solid #000",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
};

//TODO: Edit RecruiterModal
// recruiter company edit modal
const EditRecruiterCompanyModal = ({
  open,
  setOpen,
  data,
  editRecruiterCompanyDetails,
  masterCompanyVal,
  hiringCompanies,
  countryDetails,
  recruiterMetaData,
  childMetaData,
  defaultCountry,
  metaRecruiterCompanyDetails,
}) => {
  var flag = 0;
  const dispatch = useDispatch();
  const { getThemeColor } = useColorMode();
  const [masterCompanyIdVal, setMasterCompanyIdVal] = useState({});
  const [masterCompanyName, setMasterCompanyName] = useState("");
  const [rCompanyName, setRCompanyName] = useState("");
  const [rCompanyWebsite, setRCompanyWebsite] = useState("");
  // const [phoneNumber, setPhoneNumber] = useState("");
  // const [phoneNumberID, setPhoneNumberID] = useState("");
  // const [phoneNumberInternal, setPhoneNumberInternal] = useState("");
  // const [phoneNumberInternalID, setPhoneNumberInternalID] = useState("");
  const [newSubmit, setNewSubmit] = useState(false);
  const [recruiterCompanyDecLength, setRecruiterCompanyDecLength] = useState(0);
  const [notify, setNotify] = useState([{ cname: "", cphone: "", email: "" }]);
  const [template, setTemplate] = useState([
    {
      templateIndex: "",
      templateName: "",
      paramNumber: "",
      params: [],
      verbiage: "",
    },
  ]);
  const [emailValidate, setEmailValidate] = useState(false);

  const emailInitialState = [{ email: "" }];

  // const [countryDetails, setCountryDetails] = useState([]);
  const [countrySelected, setCountrySelected] = useState(defaultCountry);
  const [countryInternalSelected, setCountryInternalSelected] = useState("");
  const [phonePrefix, setPhonePrefix] = useState("");
  const [phonePrefixInternal, setPhonePrefixInternal] = useState("");
  const [repeaterError, setRepeaterError] = useState(false);
  const [peopleToNotifyAlert, setPeopleToNotifyAlert] = useState(null);
  const [emailNotify, setEmailNotify] = useState([{ email: "" }]);

  const [metaCompanyDetails, setMetaCompanyDetails] = useState([]);
  const [childCompanySelected, setChildCompanySelected] = useState(null);
  const [recruiterCompanySelected, setRecruiterCompanySelected] = useState(null);
  const [childCompanyDetails, setChildCompanyDetails] = useState("");
  const [recruiterCompanyDetails, setRecruiterCompanyDetails] = useState("");

  useEffect(() => {
    dispatch(getChildCompanies()).then((res) => {
      setMetaCompanyDetails(res.payload);
    });
  }, []);


  useEffect(() => {
    if (childCompanySelected && childCompanySelected !== "") {
      dispatch(getCompanyNumber(childCompanySelected)).then((res) => {
        let childDetails = res.payload?.[0];
        if (childDetails?.display_phone_number) {
          let parts = childDetails.display_phone_number.trim().split(" ");
          const countryCode = (parts[0] || "").replace(/\D/g, "");
          setCountrySelected(countryCode);
          setChildCompanyDetails({
            display_phone_number: parts.slice(1).join("").trim(),
            internal_id: childDetails.id,
            id: childCompanySelected,
          });
          setValue("phone_number", parts.slice(1).join("").trim());
          setValue("phone_number_id", childDetails.id);
        } else {
          setChildCompanyDetails({
            display_phone_number: data?.phone_number || "",
            internal_id: data?.phone_number_id || "",
            id: childCompanySelected,
          });
        }
      });
    }
  }, [childCompanySelected]);

  useEffect(() => {
    if (recruiterCompanySelected && recruiterCompanySelected !== "") {
      dispatch(getCompanyNumber(recruiterCompanySelected)).then((res) => {
        const recruiterDetails = res.payload?.[0];
        if (recruiterDetails?.display_phone_number) {
          const parts = recruiterDetails.display_phone_number.trim().split(" ");
          const countryCode = (parts[0] || "").replace(/\D/g, "");
          setCountryInternalSelected(countryCode);
          setRecruiterCompanyDetails({
            display_phone_number: parts.slice(1).join("").trim(),
            internal_id: recruiterDetails.id,
            id: recruiterCompanySelected,
          });
          setValue("phone_number_internal", parts.slice(1).join("").trim());
          setValue("phone_number_id_internal", recruiterDetails.id);
        } else {
          setRecruiterCompanyDetails({
            display_phone_number: data?.phone_number_internal || "",
            internal_id: data?.phone_number_id_internal || "",
            id: recruiterCompanySelected,
          });
        }
      });
    }
  }, [recruiterCompanySelected]);

  const initailState = {
    name: "",
    website: "",
    description: "",
    masterCompanyId: "",
    masterCompanyName: "",
    companyForHint: "",
    phone_number_id: "",
    phone_number_internal: "",
    phone_number: "",
    phone_number_id_internal: "",
    linkedinPage: "",
    instagramPage: "",
    careerPage: "",
    xHandle: "",
    //emailIdToListen: "",
    // reapplyDuration: "",
    //peopleToBeNotified:notify,
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues: initailState,
    resolver: yupResolver(schema),
  });
  //console.log("data111: ", data);
  const handleDescriptionKeyUp = (event) => {
    setRecruiterCompanyDecLength(event.target.value.length);
  };
  const handleClose = () => {
    setOpen(false);
    setNewSubmit(false);
    setCountrySelected("");
    setCountryInternalSelected("");
    setTemplateClick(true);
    setConditionCheck(true);
    setChildCompanyDetails("");
    setRecruiterCompanyDetails("");
    // setRecruiterMetaCompany("");
    // setChildMetaCompany("");
  };

  const phoneNumberId = watch("phone_number_id");
  const phoneNumberInternal = watch("phone_number_internal");
  const phoneNumber = watch("phone_number");
  const phoneNumberIdInternal = watch("phone_number_id_internal");

  const [templateClick, setTemplateClick] = useState(true);
  const [conditionCheck, setConditionCheck] = useState(true);
  const [valuex, setValuex] = useState(null);
  // const [iflowCompanyData, setIflowCompanyData] = useState("");
  const [iflowCompanyId, setIflowCompanyId] = useState("");
  const [iflowRecCompanyId, setIflowRecCompanyId] = useState("");
  const [alert, setAlert] = useState(false);
  const [alertContent, setalertcontent] = useState("");
  const [openingStatus, setOpeningStatus] = useState(false);
  const [alertStatus, setAlertStatus] = useState(Boolean);
  const [iflowCompanyDataId, setIflowCompanyDataId] = useState("");
  const iflowCompanyDetailsById = useSelector(
    (state) => state.hiringCompanyReducer.idFlowHiringCompany,
  );
  const handleTemplate = () => {
    const formValues = getValues();

    if (formValues.phone_number == "") {
      setValue("phone_number", childCompanyDetails.display_phone_number);
      setValue("phone_number_id", childCompanyDetails.internal_id);
      setValue(
        "phone_number_internal",
        recruiterCompanyDetails.display_phone_number,
      );
      setValue("phone_number_id_internal", recruiterCompanyDetails.internal_id);
    }

    if (templateClick === false) {
      if (
        formValues.phone_number?.length >= 10 &&
        formValues.phone_number_id?.length >= 10 &&
        formValues.phone_number_internal?.length >= 10 &&
        formValues.phone_number_id_internal?.length >= 10
      ) {
        setTemplateClick(true);
        setConditionCheck(true);
      } else {
        setConditionCheck(false);
      }
    } else if (templateClick === true) {
      setTemplateClick(false);
    }
  };
  // console.log("DATA",data);
  // console.log("editRecruiterCompanyDetails",editRecruiterCompanyDetails)

  const iflowChildCompanyData = useSelector(
    (state) => state.recruitmentReducer?.iflowChildCompany,
  );
  const iflowHiringcompanyData = useSelector(
    (state) => state.hiringCompanyReducer.iflowHiringCompany,
  );
  const handleiFlowData = (valuex) => {
    dispatch(
      // postRecruitmentCompanyInFlow({
      updateIflowHiringCompany(data.iFlowCompanyId, {
        resource: {
          ...iflowCompanyDetailsById,
          name: valuex,
          processName: "Initiation Process Pre-Screening",
        },
      }),
    )
      .then((res) => {
        if (res.payload) {
          setIflowRecCompanyId(res?.payload?.data);
          setIflowCompanyDataId(res?.payload?.data);
        } else {
          setIflowRecCompanyId(iflowRecCompanyId);
          setAlert(true);
          setAlertStatus(false);
          setalertcontent("Company Already Exists!");
        }
      })
      .catch((err) => {
        setIflowRecCompanyId(iflowRecCompanyId);
        setAlert(true);
        setAlertStatus(false);
        setalertcontent("Company Already Exists!");
      });
  };
  const handleiFlowDataOLD = (valuex) => {
    var iflowCompID = "";
    if (iflowRecCompanyId) {
      // console.log('++++',iflowRecCompanyId)
      iflowCompID = iflowRecCompanyId;
    } else {
      // console.log('++++',data)
      iflowCompID = data.iFlowCompanyId;
    }
    // console.log('+++iflowCompDetails+++', data)
    // console.log('++++iflowCompanyID++++', iflowCompID)
    dispatch(
      // postRecruitmentCompanyInFlow({
      postHiringCompanyInFlow({
        resource: {
          name: valuex,
          code: null,
          friendlyname: valuex,
          parentid: iflowCompanyId,
          comptype: "CUSTOMER",
          contacts: [],
          aliases: [],
          vendorsapid: [],
          customersapid: [],
          accountManagers: [],
          otherEmails: [],
          otherPhoneNumbers: [],
          partnerLevel: "",
          addresses: [
            {
              line: "",
              country: "India",
              state: "",
              city: "",
              postalcode: "",
              type: "PA",
              friendlyaddress: "",
            },
          ],
          group: null,
          primaryEmailId: "",
          primaryPhoneNumber: "",
          registered: "India",
          employeeName: "",
          employeeAddress: "",
          dob: "",
          aadhaarId: "",
          panId: "",
          companyId: iflowCompID,
          gstinIds: [],
          ieCode: "",
          blackList: false,
          isactive: true,
          aadhaar: {
            aadhaarId: "",
            name: "",
            address: "",
            gender: "",
            care_of: "",
            dob: "",
            email: "",
            id: "",
            message: "",
            mobile_hash: "",
            photo_link: "",
            ref_id: "",
            split_address: null,
            status: "",
            year_of_birth: "",
          },
          pan: {
            id: "",
            name: "",
            dob: "",
            fathersName: "",
          },
          flags: {
            mobilemsa: null,
            voicemsa: null,
            smsmsa: null,
            iotmsa: null,
            nda: null,
            ndaiot: null,
          },
          processName: "Initiation Process Pre-Screening",
        },
      }),
    ).then((res) => {
      setIflowCompanyDataId(res?.dataIflowHiringCompany);
      if (res.dataIflowRecruitmentCompany != undefined) {
        let recRes = res.dataIflowRecruitmentCompany.data;
        // console.log(recRes)
        // console.log(recRes.data)
        /* if(recRes[data] != '' && recRes[data] != null && recRes[data] != undefined){
          console.log(recRes[data])
        } */
        if (recRes.data) {
          if (typeof recRes.data == "number") {
            setIflowRecCompanyId(recRes.data);
          } else {
            setAlert(true);
            setAlertStatus(true);
            setalertcontent("Company Already Exists!");
          }
        } else {
          setIflowRecCompanyId(iflowRecCompanyId);
        }

        // setIflowRecCompanyId('')
        // console.log("dataGET", res.dataIflowHiringCompany);
        /* dispatch(getHiringCompanyThroughData(res?.dataIflowHiringCompany))
          .then((res) => {
            // console.log("helllooejdidbd", res?.idFlowHiringCompany?.code);
            setIflowCompanyData(res?.idFlowHiringCompany?.code);
          })
          .catch((err) => {
            console.log(err);
          }); */
      } else {
        setIflowRecCompanyId(iflowRecCompanyId);
        setAlert(true);
        setAlertStatus(true);
        setalertcontent("Company Already Exists!");
      }
    });
  };
  const AlerthandleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert(false);
  };

  const onSubmit = (dataToEdit) => {
    setValue("phone_number", childCompanyDetails.display_phone_number);
    setValue("phone_number_id", childCompanyDetails.internal_id);
    setValue(
      "phone_number_internal",
      recruiterCompanyDetails.display_phone_number,
    );
    setValue("phone_number_id_internal", recruiterCompanyDetails.internal_id);

    let res = validatePeopleToBeNotified(notify);
    if (!res.status) {
      setPeopleToNotifyAlert(res.message);
      setRepeaterError(true);
      return;
    }
    setRepeaterError(false);
    setPeopleToNotifyAlert(null);
    if (rCompanyName === "" || masterCompanyIdVal === null) {
      // console.log("not Ready to update some data key missing");
      return;
    }

    flag = false;
    emailNotify.forEach((el) => {
      if (el.isDuplicate === true) {
        //setEmailValidate(true);
        //return;
        flag = true;
        return;
      }
    });
    if (flag === true) {
      setEmailValidate(true);
      // console.log("sahna");
      return;
    }

    setEmailValidate(false);

    var finalTemplateValues = {};
    template.forEach((val) => {
      if (val.templateIndex && val.templateIndex !== "null" && val.templateIndex !== "undefined" && val.templateIndex !== "") {
        finalTemplateValues[val.templateIndex] = {
          name: val.templateName,
          params: val.params.toString(),
          verbiage: val.verbiage,
        };
      }
    });

    let newData = {
      ...dataToEdit,
      masterCompanyId: masterCompanyIdVal.CompanyId,
      masterCompanyName: masterCompanyIdVal.name,
      peopleToBeNotified: notify,
      templates: finalTemplateValues,
      emailIdToListen: emailNotify,
      iFlowCompanyId: valuex?.id ? valuex.id : iflowCompanyDataId,
      id: dataToEdit.CompanyId,
    };

    newData.phone_number_prefix = countrySelected;
    newData.phone_number_internal_prefix = countryInternalSelected;
    newData.recruiterMetaCompany = recruiterCompanySelected;
    newData.childMetaCompany = childCompanySelected;
    editRecruiterCompanyDetails(newData);
    setTemplateClick(true);
    setOpen(false);
    // setNewSubmit(false);
  };

  const compareStrings = (a, b) => {
    // Assuming you want case-insensitive comparison
    a = a.toLowerCase();
    b = b.toLowerCase();
    return a < b ? -1 : a > b ? 1 : 0;
  };

  let menustr = "";
  let phoneNumberPrefix = "";
  let phoneNumberInternalPrefix = "";
  const countryListDetails = useSelector(
    (state) => state.countryReducer.country,
  );
  // Changing the priority of the Country Data
  // console.log(countryListDetails)
  //const countryListDetails = []
  let countryData = countryListDetails;

  let newCountryData = [];
  //console.log("yyyyyyy",newCountryData)
  countryData.forEach((resp) => {
    if (resp.numeric_code == "356") {
      newCountryData.push(resp);
    }
    if (resp.numeric_code == "840") {
      newCountryData.push(resp);
    }
  });
  newCountryData.sort(function (a, b) {
    return compareStrings(a.name, b.name);
  });
  let newCountryData1 = countryData;
  newCountryData1.sort(function (a, b) {
    return compareStrings(a.name, b.name);
  });
  newCountryData1.forEach((res) => {
    newCountryData.push(res);
  });
  // Changing the priority of the Country Data

  useEffect(() => {
    if (peopleToNotifyAlert) {
      setTimeout(() => {
        setPeopleToNotifyAlert(null);
      }, 400);
    }
  }, [peopleToNotifyAlert ? true : false]);
  useEffect(() => {
    reset(data);
    if (data?.iFlowCompanyId) {
      dispatch(getHiringCompanyThroughData(data?.iFlowCompanyId));
    }
    setOpeningStatus(false);
    // Check the Opening
    // console.log(data)
    if (open) {
      dispatch(getOpeningByCompanyActionFn(data.name)).then((res) => {
        // setMetaCompanyDetails(res.payload);
        // console.log(res.payload)
        let openingDetails = res.payload;
        if (openingDetails != undefined) {
          setOpeningStatus(true);
        }
      });
    }
    // Check the Opening
    setTemplateClick(false);
    setRecruiterCompanyDecLength(data?.description?.length || 0);
    setRCompanyName(data.name);
    setMasterCompanyIdVal(masterCompanyVal);
    setEmailNotify([{ email: "" }]);
    setNotify([{ cname: "", cphone: "", email: "" }]);
    setTemplate([
      {
        templateIndex: "",
        templateName: "",
        paramNumber: "",
        params: [],
        verbiage: "",
      },
    ]);

    if (data.phone_number) {
      setValue("phone_number", data.phone_number);
    }

    if (data.phone_number_id) {
      setValue("phone_number_id", data.phone_number_id);
    }

    if (data.phone_number_internal) {
      setValue("phone_number_internal", data.phone_number_internal);
    }

    if (data.phone_number_id_internal) {
      setValue("phone_number_id_internal", data.phone_number_id_internal);
    }

    if (data.emailIdToListen != undefined) {
      if (data.emailIdToListen.length > 0) {
        setEmailNotify(data.emailIdToListen);
      }
    }

    if (open) {
      if (data.childMetaCompany != undefined && data.childMetaCompany != "") {
        setChildCompanySelected(data.childMetaCompany);
      } else {
        setChildCompanySelected(null);
      }

      if (data.recruiterMetaCompany != undefined && data.recruiterMetaCompany != "") {
        setRecruiterCompanySelected(data.recruiterMetaCompany);
      } else {
        setRecruiterCompanySelected(null);
      }

      setTimeout(() => {
        setCountrySelected(
          data.phone_number_prefix
            ? removePlusFromPhoneNumber(data.phone_number_prefix)
            : countryDetails[0]?.["phone_code"],
        );
        setCountryInternalSelected(
          data.phone_number_internal_prefix
            ? removePlusFromPhoneNumber(data.phone_number_internal_prefix)
            : countryDetails[0]?.["phone_code"],
        );
      }, 1000);
    }

    if (data.peopleToBeNotified != undefined) {
      if (data.peopleToBeNotified.length > 0) {
        setNotify(data.peopleToBeNotified);
      }
    }

    if (data.templates != undefined && data.templates != "") {
      var templates = data.templates;
      var updatedTemplates = [];
      var templateKeys = Object.keys(templates);
      var templateValues = Object.values(templates);
      var paramNumber = "";
      if (templateKeys != []) {
        templateKeys.forEach((val, key) => {
          if (val && val !== "null" && val !== "undefined" && val !== "") {
            paramNumber = templateValues[key]["params"].split(",");
            updatedTemplates.push({
              templateIndex: val,
              templateName: templateValues[key]["name"],
              paramNumber: paramNumber.length,
              params: paramNumber,
              verbiage: templateValues[key]["verbiage"],
            });
          }
        });
        // console.log(updatedTemplates)
        if (updatedTemplates.length > 0) {
          setTemplate(updatedTemplates);
        }
      }
      // setTemplate([])

      // console.log('+++++++', masterCompanyVal)
    }

    /*if (childCompanySelected != "") {
      dispatch(getCompanyNumber(childCompanySelected)).then((res) => {
        let childDetails = res.payload[0];
        if (
          childDetails != undefined &&
          childDetails["display_phone_number"] != undefined
        ) {
          let childCompanyArr = childDetails["display_phone_number"].split(" ");
          setTimeout(() => {
            setCountrySelected(removePlusFromPhoneNumber(childCompanyArr[0]));
          }, 1000);
          setChildCompanyDetails({
            display_phone_number: childCompanyArr[1] + childCompanyArr[2],
            internal_id: childDetails["id"],
            id: childCompanySelected,
          });
        } else {
          setChildCompanyDetails({
            display_phone_number: data.phone_number,
            internal_id: data.phone_number_id,
            id: childCompanySelected,
          });
        }
      });
    }*/
  }, [data, masterCompanyVal, open]);


  //console.log("metaCompanyDetails", metaCompanyDetails)
  const recruiterMetaValue =
    metaCompanyDetails?.find(
      (opt) => opt.id === recruiterCompanySelected
    ) || null;
  const handlePhoneChange = (event) => {
    // console.log(event.target.value)
    let phone_prefix = event.target.value;
    setCountrySelected(removePlusFromPhoneNumber(phone_prefix));
    setPhonePrefix(removePlusFromPhoneNumber(phone_prefix));
  };

  const handlePhoneInternalChange = (event) => {
    // console.log(event.target.value)
    let phone_internal_prefix = event.target.value;
    setCountryInternalSelected(
      removePlusFromPhoneNumber(phone_internal_prefix),
    );
    setPhonePrefixInternal(removePlusFromPhoneNumber(phone_internal_prefix));
  };

  var updatedHiringCompanies = [];
  hiringCompanies.forEach((val, key) => {
    if (val.companyStatus != false) {
      updatedHiringCompanies.push(val);
    }
  });

  hiringCompanies = updatedHiringCompanies;
  // console.log("masterCompanyVal", masterCompanyVal);
  // console.log("dataName",data?.name)
  // console.log(" masterCompanyIdVal", masterCompanyIdVal);
  // console.log("valuex",valuex)

  const templateID = {
    childCompanyID: childCompanyDetails
      ? childCompanyDetails.id
      : childCompanySelected,
    recruiterCompanyID: recruiterCompanyDetails
      ? recruiterCompanyDetails.id
      : recruiterCompanySelected,
  };

  return (
    <>
      {alert && (
        <ApiAlert
          open={alert}
          snackbaronClose={AlerthandleClose}
          alertonClose={AlerthandleClose}
          alertType={alertStatus ? "success" : "error"}
          Content={alertContent}
        />
      )}
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95vw", md: 800 },
            maxHeight: "90vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            border: "1px solid #000",
            boxShadow: 24,
            p: { xs: 2, md: 4 },
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  fontWeight: 600,
                  color: "primary.darkText",
                  textAlign: "center",
                }}
              >
                Edit Recruitment Company
              </Typography>

              {/*{openingStatus && (
                <span className="note">
                  Note:{" "}
                  <i>
                    Some fields are disabled because opening is in progress!
                  </i>
                </span>
              )}*/}

              <IconButton
                onClick={handleClose}
                sx={{ position: "absolute", top: 8, right: 8 }}
              >
                <CloseIcon />
              </IconButton>

              <Autocomplete
                id="hiring-company-autocomplete"
                options={hiringCompanies}
                sx={{ width: "100%" }}
                getOptionLabel={(option) => option?.name || " "}
                defaultValue={masterCompanyVal}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                onChange={(event, value) => setMasterCompanyIdVal(value)}
                //readOnly={openingStatus}
                //className={openingStatus ? "readClass" : ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<ReuseableLabel label={"Hiring Company"} />}
                    error={newSubmit && masterCompanyIdVal === null}
                    helperText={
                      newSubmit &&
                      masterCompanyIdVal === null &&
                      "Hiring Company is required"
                    }
                  />
                )}
              />

              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    sx={{ width: "100%" }}
                    value={data?.name}
                    //readOnly={openingStatus}
                    //className={openingStatus ? "readClass" : ""}
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        setValuex({ name: newValue });
                      } else if (newValue && newValue.inputValue) {
                        handleiFlowData(newValue.inputValue);
                        setValuex({ name: newValue.inputValue });
                      } else {
                        setValuex(newValue);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const { inputValue } = params;
                      const uniqueNames = new Set();
                      const filtered = options.filter((option) => {
                        const optionNameLowerCase = option.name.toLowerCase();
                        if (uniqueNames.has(optionNameLowerCase)) return false;
                        uniqueNames.add(optionNameLowerCase);
                        return true;
                      });
                      const matchedOptions = filtered.filter((option) =>
                        option.name
                          .toLowerCase()
                          .includes(inputValue.toLowerCase()),
                      );
                      if (
                        inputValue !== "" &&
                        !uniqueNames.has(inputValue.toLowerCase())
                      ) {
                        matchedOptions.push({
                          inputValue,
                          name: `Edit "${inputValue}"`,
                        });
                      }
                      return matchedOptions;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="recruitment-company-name"
                    options={iflowHiringcompanyData}
                    getOptionLabel={(option) => {
                      if (typeof option === "string") return option;
                      if (option.inputValue) return option.inputValue;
                      return option.name;
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.name}</li>
                    )}
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <ReuseableLabel label={"Recruitment Company Name"} />
                        }
                        {...register("name")}
                        error={Boolean(errors.name)}
                        helperText={errors.name?.message}
                      />
                    )}
                  />
                )}
              />

              <TextField
                sx={{ width: "100%" }}
                label={<ReuseableLabel label={"Company Website"} />}
                variant="outlined"
                name="website"
                {...register("website", {})}
                error={Boolean(errors.website)}
                helperText={errors.website?.message}
              />

              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                sx={{ width: "100%" }}
              >
                <Autocomplete
                  id="recruiter-meta-company"
                  options={metaCompanyDetails || []}
                  // readOnly={openingStatus}
                  //className={openingStatus ? "readClass" : ""}
                  getOptionLabel={(option) => option?.name || ""}
                  value={recruiterMetaValue}

                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }

                  onChange={(event, value) => {
                    setRecruiterCompanyDetails("");
                    setRecruiterCompanySelected(value?.id || "");
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.name}
                    </li>
                  )}
                  sx={{ width: "100%" }}
                  /*onChange={(event, value) => {
                    setRecruiterCompanyDetails("");
                    setRecruiterCompanySelected(value);
                  }}*/

                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <ReuseableLabel label={"Meta Company for Recruiter"} />
                      }
                      error={newSubmit && recruiterCompanySelected === ""}
                      helperText={
                        newSubmit &&
                        recruiterCompanySelected === "" &&
                        "Meta Company for Recruiter is required"
                      }
                    />
                  )}
                />
                <Autocomplete
                  id="candidate-meta-company"
                  options={metaRecruiterCompanyDetails}
                  getOptionLabel={(option) => option?.name || ""}
                  value={metaRecruiterCompanyDetails?.find((opt) => opt.id === childCompanySelected) || null}
                  //readOnly={openingStatus}
                  //className={openingStatus ? "readClass" : ""}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.name}
                    </li>
                  )}
                  sx={{ width: "100%" }}
                  onChange={(event, value) => {
                    setChildCompanyDetails("");
                    setChildCompanySelected(value?.id || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <ReuseableLabel label={"Meta Company for Candidate"} />
                      }
                      error={newSubmit && childCompanySelected === ""}
                      helperText={
                        newSubmit &&
                        childCompanySelected === "" &&
                        "Meta Company is required"
                      }
                    />
                  )}
                />
              </Stack>

              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                sx={{ width: "100%" }}
              >
                <Box sx={{ display: "flex", width: { xs: "100%", md: "50%" } }}>
                  <Select
                    id="phone_flag_internal"
                    //readOnly={openingStatus}
                    //className={openingStatus ? "readClass" : ""}
                    value={countryInternalSelected}
                    onChange={handlePhoneInternalChange}
                    sx={{ minWidth: 90 }}
                  >
                    {countryDetails?.map((res, idx) => (
                      <MenuItem key={idx} value={res.phone_code}>
                        {res.iso2} ({res.phone_code})
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    sx={{ width: "100%" }}
                    label={
                      <ReuseableLabel label={"WhatsApp Recruiter Connect #"} />
                    }
                    variant="outlined"
                    //readOnly={openingStatus}
                    //className={openingStatus ? "readClass" : ""}
                    inputProps={{ maxLength: 15 }}
                    {...register("phone_number_internal")}
                    error={Boolean(errors.phone_number_internal)}
                    helperText={errors.phone_number_internal?.message}
                  />
                </Box>
                <TextField
                  sx={{ width: { xs: "100%", md: "50%" } }}
                  label={
                    <ReuseableLabel
                      label={"WhatsApp Recruiter Connect Meta ID"}
                    />
                  }
                  variant="outlined"
                  //readOnly={openingStatus}
                  //className={openingStatus ? "readClass" : ""}
                  inputProps={{ maxLength: 15 }}
                  {...register("phone_number_id_internal")}
                  error={Boolean(errors.phone_number_id_internal)}
                  helperText={errors.phone_number_id_internal?.message}
                />
              </Stack>

              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                sx={{ width: "100%" }}
              >
                <Box sx={{ display: "flex", width: { xs: "100%", md: "50%" } }}>
                  <Select
                    id="phone_flag"
                    // readOnly={openingStatus}
                    //className={openingStatus ? "readClass" : ""}
                    value={countrySelected}
                    onChange={handlePhoneChange}
                    sx={{ minWidth: 90 }}
                  >
                    {countryDetails?.map((res, idx) => (
                      <MenuItem key={idx} value={res.phone_code}>
                        {res.iso2} ({res.phone_code})
                      </MenuItem>
                    ))}
                  </Select>
                  <TextField
                    sx={{ width: "100%" }}
                    label={
                      <ReuseableLabel label={"WhatsApp Candidate Connect #"} />
                    }
                    variant="outlined"
                    //readOnly={openingStatus}
                    //className={openingStatus ? "readClass" : ""}
                    inputProps={{ maxLength: 15 }}
                    {...register("phone_number")}
                    error={Boolean(errors.phone_number)}
                    helperText={errors.phone_number?.message}
                  />
                </Box>
                <TextField
                  sx={{ width: { xs: "100%", md: "50%" } }}
                  label={
                    <ReuseableLabel
                      label={"WhatsApp Candidate Connect Meta ID"}
                    />
                  }
                  variant="outlined"
                  //readOnly={openingStatus}
                  //className={openingStatus ? "readClass" : ""}
                  inputProps={{ maxLength: 15 }}
                  {...register("phone_number_id")}
                  error={Boolean(errors.phone_number_id)}
                  helperText={errors.phone_number_id?.message}
                />
              </Stack>

              <TextField
                sx={{ width: "100%" }}
                label={<ReuseableLabel label={"Company Abbreviation"} />}
                variant="outlined"
                {...register("companyForHint")}
                error={Boolean(errors.companyForHint)}
                helperText={errors.companyForHint?.message}
              />

              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                sx={{ width: "100%" }}
              >
                <TextField
                  sx={{ width: "100%" }}
                  label="LinkedIn Page"
                  {...register("linkedinPage")}
                  error={Boolean(errors.linkedinPage)}
                  helperText={errors.linkedinPage?.message}
                />
                <TextField
                  sx={{ width: "100%" }}
                  label="Instagram Page"
                  {...register("instagramPage")}
                  error={Boolean(errors.instagramPage)}
                  helperText={errors.instagramPage?.message}
                />
              </Stack>

              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                sx={{ width: "100%" }}
              >
                <TextField
                  sx={{ width: "100%" }}
                  label="Career Page"
                  {...register("careerPage")}
                  error={Boolean(errors.careerPage)}
                  helperText={errors.careerPage?.message}
                />
                <TextField
                  sx={{ width: "100%" }}
                  label="X Handle"
                  {...register("xHandle")}
                  error={Boolean(errors.xHandle)}
                  helperText={errors.xHandle?.message}
                />
              </Stack>

              <FormControl fullWidth error={Boolean(errors.reapplyDuration)}>
                <InputLabel id="reapply-duration-label">
                  <ReuseableLabel label={"Reapply Duration"} />
                </InputLabel>
                <Controller
                  name="reapplyDuration"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Please select an option" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      labelId="reapply-duration-label"
                      label="Reapply Duration"
                    >
                      <MenuItem value="">Please select an option</MenuItem>
                      <MenuItem value={"0"}>0 day</MenuItem>
                      <MenuItem value={"15"}>15 days</MenuItem>
                      <MenuItem value={"30"}>30 days</MenuItem>
                      <MenuItem value={"90"}>90 days</MenuItem>
                      <MenuItem value={"180"}>180 days</MenuItem>
                      <MenuItem value={"365"}>365 days</MenuItem>
                    </Select>
                  )}
                />
                {errors.reapplyDuration && (
                  <FormHelperText>
                    {errors.reapplyDuration.message}
                  </FormHelperText>
                )}
              </FormControl>

              <Box sx={{ width: "100%" }}>
                <TextField
                  multiline
                  sx={{ width: "100%" }}
                  label="Company Description"
                  variant="outlined"
                  rows={5}
                  inputProps={{ maxLength: 4000 }}
                  {...register("description")}
                  onKeyUp={handleDescriptionKeyUp}
                />
                <Typography
                  variant="caption"
                  sx={{
                    float: "right",
                    mt: 0.5,
                    color:
                      recruiterCompanyDecLength < 4000
                        ? "text.secondary"
                        : "error.main",
                  }}
                >
                  {recruiterCompanyDecLength}/4000
                </Typography>
              </Box>

              <Box sx={{ width: "100%" }}>
                <EmailRepeaters
                  emailFormValues={emailNotify}
                  setEmailFormValues={setEmailNotify}
                  emailValidate={emailValidate}
                  setEmailValidate={setEmailValidate}
                  companyId={data?.CompanyId}
                />
              </Box>
              <Box sx={{ width: "100%" }}>
                <PeopleToNotifyRepeater
                  formValues={notify}
                  setFormValues={setNotify}
                  countryDetails={countryDetails}
                  countrySelected={removePlusFromPhoneNumber(defaultCountry)}
                  repeaterError={repeaterError}
                  setRepeaterError={setRepeaterError}
                />
                {peopleToNotifyAlert && (
                  <Typography color="error" variant="caption">
                    {peopleToNotifyAlert}
                  </Typography>
                )}
              </Box>

              <Box sx={{ width: "100%", mt: 2 }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Stack direction="column">
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: getThemeColor("#000", "#fff"),
                      }}
                    >
                      Meta Template :
                    </Typography>
                    {!conditionCheck && (
                      <Typography color="error" variant="caption">
                        Please fill the required fields
                      </Typography>
                    )}
                  </Stack>
                  <IconButton onClick={handleTemplate}>
                    {templateClick ? (
                      <RemoveCircleIcon
                        sx={{ color: getThemeColor("#000", "#fff") }}
                      />
                    ) : (
                      <AddCircleIcon
                        sx={{ color: getThemeColor("#000", "#fff") }}
                      />
                    )}
                  </IconButton>
                </Stack>
                <hr style={{ borderColor: getThemeColor("#000", "#fff") }} />
              </Box>

              {templateClick && (
                <Box sx={{ width: "100%" }}>
                  <TemplateRepeater
                    templateValues={template}
                    setTemplateValues={setTemplate}
                    templateID={templateID}
                  />
                </Box>
              )}

              <Stack
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                sx={{ width: "100%", pt: 2 }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button variant="contained" color="primary" type="submit">
                  Save
                </Button>
              </Stack>
            </Box>
          </form>
        </Box>
      </Modal>
    </>
  );
};
